// @flow weak

import { connect } from 'react-redux';
import { InlineUpgradeTrigger } from '@zapier/design-system-revenue';

import FlowActions from 'app/redux-boneyard/flow/FlowActions';

const mapDispatchToProps = (dispatch, { autoOpen, flowId }) => ({
  onUpgradeFinish() {
    // Attempt to unpause zap
    if (autoOpen && flowId) {
      dispatch(FlowActions.unpause(flowId));
    }
  },
});

export default connect(null, mapDispatchToProps)(InlineUpgradeTrigger);
